import { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext(null);

function readStoredPreference(key, fallback) {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return fallback;
    return window.localStorage.getItem(key) || fallback;
  } catch {
    return fallback;
  }
}

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => readStoredPreference('lk_theme', 'light'));
  const [accent, setAccent] = useState(() => readStoredPreference('lk_accent', 'teal'));
  const [density, setDensity] = useState(() =>
    readStoredPreference('lk_density', 'comfortable'),
  );

  useEffect(() => {
    if (typeof document === 'undefined') return;
    document.documentElement.dataset.theme = theme;
    document.documentElement.dataset.accent = accent;
    document.documentElement.dataset.density = density;
    try {
      localStorage.setItem('lk_theme', theme);
      localStorage.setItem('lk_accent', accent);
      localStorage.setItem('lk_density', density);
    } catch {
      /* localStorage unavailable (private mode) — ignore */
    }
  }, [theme, accent, density]);

  return (
    <ThemeContext.Provider value={{ theme, accent, density, setTheme, setAccent, setDensity }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be inside ThemeProvider');
  return ctx;
}
